import {useState} from "react" 

/**
 * Génère un objet pour le destructuring
 * Permet la gestion de deux messages et leur suppression
 * 
 * @return {Object} Permet de filtrer le retour par destructuring
 */
export function useMsg () {

	const [msg, setMsg0] = useState('')
	const [msg2, setMsg02] = useState('')

	const cleanMsg = (time=5000) => {
	    setTimeout(e => {
	          setMsg0('')
	        }, time)
	  }


	const genMsg = (text, type_alert='alert danger', fade='fadeout5', setMess) => {
		setMess('<div class="'+type_alert+' ' + fade +'"><br>' + text + '<br><br></div>')
		if(fade) {
			const time = fade.replace('fadeout', '')*1000
			cleanMsg(time)
		}
	}

	const setMsg = (text, type_alert, fade) => genMsg(text, type_alert, fade, setMsg0)
	const setMsg2 = (text, type_alert, fade) => genMsg(text, type_alert, fade, setMsg02)
	
  return {
  	msg, setMsg, msg2, setMsg2
  }
}